import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=6f46445e&scoped=true&"
import script from "./FrontPage.vue?vue&type=script&lang=js&"
export * from "./FrontPage.vue?vue&type=script&lang=js&"
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=6f46445e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46445e",
  null
  
)

export default component.exports